<template>
  <div class="d-flex">
  <div class="col-md-3 panel-details card-totalDespesas" >
      <div class="info-panel">
        <div class="panel-details">
        <div class="panel-details-head">
         <i class="fas fa-edit mr-2" ></i>INFORMAÇÕES
        </div>
         <div class="panel-details-body">
           <p class="subtitle">Dados Colaborador</p>

          <div class="d-flex mt-2">
            <div class="w-100">
              <p class="label">Código</p>
              <p class="value">{{dataExpenseDetails.coordenador !== null || dataExpenseDetails.coordenador  !== undefined ? dataExpenseDetails.funcionario.codigo : "N/D"}}</p>
            </div>
          </div>

           <div class="d-flex mt-2">
            <div class="w-100">
              <p class="label">Colaborador</p>
              <p class="value">{{dataExpenseDetails.coordenador !== null || dataExpenseDetails.coordenador  !== undefined ? dataExpenseDetails.funcionario.nome : "N/D"}}</p>
            </div>
           </div>
           <div class="d-flex mt-3">
            <div class="w-50">
              <p class="label">Data</p>
              <p class="value">{{ returnFormatedData() }}</p>
            </div>
            <div>
              <p class="label">Obra</p>
              <p class="value">{{dataExpenseDetails.obra !== null || dataExpenseDetails.obra  !== undefined ? dataExpenseDetails.obra.referencia : "N/D"}}</p>
            </div>
           </div>
           <p class="subtitle mt-3">Dados da Despesa</p>
           <div class="d-flex mt-3">
            <div class="w-50">
              <p class="label">Quantidade</p>
              <p class="value">{{dataExpenseDetails.quantidade}}</p>
            </div>
            <div class="w-50">
              <p class="label">Valor</p>
              <p class="value">{{ formatMoney(dataExpenseDetails.valor)}}</p>
            </div>
           </div>

           <div class="d-flex mt-3">
            <div class="w-100">
              <p class="label">Categoria</p>
              <p class="value">{{dataExpenseDetails.categoriaDescricao}}</p>
            </div>
           </div>

           <div class="d-flex mt-3">
            <div v-if="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)" class="w-100">
              <p class="label label-data">Data Aprovação Coordenador</p>
              <p class="value">{{returnFormatedDataCoordernador()}}</p>
            </div>
           </div>

           <div class="d-flex mt-3" v-if="this.dataExpenseDetails.dataMotivoRecusa != null">
            <div  class="w-50">
              <p class="label label-data">Data Devolução</p>
              <p class="value">{{returnFormatedDataRecusa()}}</p>
            </div>
           </div>

           <div class="d-flex mt-3" v-if="dataExpenseDetails.dataEdicao != null">
            <div class="w-100">
              <p class="label label-data">Data da Edição</p>
              <p class="value">{{ dataExpenseDetails.dataEdicaoFormatada }}{{ dataExpenseDetails.dataEdicaoUsuario ? ' - ' + nomeCurto(dataExpenseDetails.dataEdicaoUsuario) : '' }}</p>
            </div>
           </div>

           <p class="subtitle mt-3" v-if="funcionariolistainicio">Dados Colaborador</p>
           <div class="mt-3" v-for="(data,index) in funcionariolistainicio" :key="index">
            <p class="label">Código do funcionário {{index + 1}}</p>
            <p class="value">{{data.funcionario.nome}}</p>
           </div>
            <!-- Botoes de aprovacao REMOVIDOS do painel de detalhe (2026-06-19): aprovacao passa a ser so pelo topo do grid (padrao unico, igual diversos). Detalhe = somente leitura. -->

          </div>
    </div>

    </div>
  </div>
    <div class="col-md-9 ">
      <div class="panel-info-details">
        <div class="panel-body">
          <DetailsHeader :btnCanceSave="!StatusNotEdit" :buttonbackCustom="false" @save="UpdateDespesasViagem" :titleHead="'Despesas De Viagem'" :iconCancel="'fas fa-times-circle'" :iconSave="'fas fa-check-circle'" ref="DetailsHeader"/>
          <!-- ZC-44: aba Log tambem no detalhe da despesa de Viagem, gemeo de Diversos. O
               DetailsHeader fica FORA das abas: Voltar/Salvar valem nas duas. -->
          <b-tabs class="mt-2">
          <b-tab :title="'Detalhe'">
            <template slot="title">
              <i class="fas fa-file-invoice-dollar text-third"></i><span class="d-md-down-none pl-1 text-third"> Detalhe da Despesa</span>
            </template>
          <div class="info-panel-details">
            <p class="subtitle">Dados da despesas</p>
            <div class="d-flex">
              <div class="col-md-3">
                <label class="label-details-despesas">Quantidade</label>
                <input disabled="true" class="form-control text-left" type="number"  v-model="funcionarioVinculados.length">
              </div>
              <div class="col-md-3">
                <label class="label-details-despesas">Valor</label>
                  <money class="form-control form-control-10 text-left"
                          v-bind="moneyFormat"
                          :placeholder="'R$ 0,00'"
                          prefix="R$ "
                          v-model="dataExpenseDetailsProp.valor"/>
              </div>
              <div class="col-md-3">
                <label class="label-details-despesas">Data</label>
                <datepicker
                  :format="'dd/MM/yyyy'"
                  :disabled="StatusNotEdit"
                  v-model="dataExpenseDetails.dataRegistroDespesa"
                  :language="ptBR"
                  :placeholder="$lang.Common.DatePlaceholder"
                  :calendar-button="true"
                  :calendar-button-icon="'fa fa-calendar'"
                  :bootstrap-styling="true"
                  :full-month-name="true"
                  :use-utc="false"
                />
              </div>

              <div class="col-md-3">
                    <label class="label-details-despesas" >Status</label>
                    <div class="status-despesas-viagem statusDespesa" :style="{'background-color': dataExpenseDetails.colorStatusDespesa}"  v-b-tooltip.hover :title="dataExpenseDetails.statusDespesaDescricao">
                        <div v-if="dataExpenseDetails.statusDespesa === 9">
                            AG. TÉCNICO
                        </div>
                        <div v-else-if="dataExpenseDetails.statusDespesa === 2">
                            AG. CONTROLADORIA
                        </div>
                        <div v-else>
                            AG. COORDENADOR
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-4">
                <div class="col-md-6">
                    <label class="label-details-despesas" >Categoria</label>
                    <select @change="changeSubCategoria" :disabled="StatusNotEdit"  class="form-control" v-model="dataExpenseDetails.categoria">
                        <option v-for="data in dataEnumCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                    </select>
                </div>
                <div class="col-md-6" v-if="dataExpenseDetails.subCategoria !== null">
                    <label class="label-details-despesas" >Sub Categoria</label>
                    <select :disabled="StatusNotEdit"  class="form-control" v-model="dataExpenseDetails.subCategoria">
                        <option v-for="data in dataAllSubCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                      </select>
                </div>

                <div class="col-md-6" v-else>
                <label class="label-details-despesas" >Sub Categoria</label>
                <select :disabled="StatusNotEdit"  class="form-control" v-model="dataExpenseDetails.subCategoriaVeiculo">
                    <option v-for="data in dataAllSubCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                  </select>
                </div>
                  </div>
                  <div class="d-flex mt-4">
                    <div v-if="dataExpenseDetails.categoria === 1" class="col-md-4">
                      <label  class="label-details-despesas" >Tipo Veiculo</label>
                  <select :disabled="StatusNotEdit"  class="form-control" v-model="dataExpenseDetails.tipoVeiculo">
                    <option v-for="data in dataAllTipoVeiculo" :key="data.value" :value="data.value">{{data.text}}</option>
                  </select>
                </div>
                <div v-if="dataExpenseDetails.categoria === 1" class="col-md-4">
                  <label class="label-details-despesas" >Placa</label>
                  <input class="form-control" v-model="dataExpenseDetails.placa" />
                </div>
                <div v-if="dataExpenseDetails.categoria === 1" class="col-md-4">
                  <label class="label-details-despesas" >Modelo</label>
                  <input class="form-control" v-model="dataExpenseDetails.modelo" />
                </div>
              </div>
              <!-- <div class="d-flex mt-4">
                <div class="col-md-12 obs-heigth">
                  <p class="label mb-2">Observação</p>
                  <p class="value">{{dataExpenseDetails.observacao}}</p>
                </div>
            </div> -->
            <div class="d-flex mt-3">
              <div class="col-md-12">
                <label class="label-details-despesas">Observação</label>
                <textarea :disabled="StatusNotEdit"  class="form-control" v-model="dataExpenseDetails.observacao" ></textarea>
              </div>
            </div>
            <div class="d-flex mt-4">
              <div class="col-md-4">
                <div class="d-flex gap">
                  <p class="subtitle">Funcionário Vinculados</p>
                  <div class="add-more-people" v-if="!
                                  StatusNotEdit" @click="addfuncionario"><i class="fas fa-plus-circle mr-1"></i></div>
                </div>
                <div class="mb-3">
                  <p class="label mb-2">Código do funcionário 1</p>
                  <div class="d-flex gap-input-funcionario">
                    <input disabled class="form-control w-25" :id="'form-funcionario-code-'" v-model="dataExpenseDetails.funcionario.codigo">
                    <input disabled class="form-control w-75" :id="'form-funcionario-text-'" v-model="dataExpenseDetails.funcionario.nome">
                  </div>
                </div>
                <div v-for="(data,index) in funcionarioVinculados" :key="index" class="mb-3">
                  <p class="label mb-2" v-if="index >= 1">Código do funcionário {{index + 1}}</p>
                  <div class="d-flex gap-input-funcionario" v-if="index >= 1" >
                  <div class="remove-more-people"  @click="removerfuncionario(index)"><i class="fas fa-minus-circle"></i></div>
                      <input :disabled="StatusNotEdit" class="form-control w-25" :id="'form-funcionario-code-' + index"  @change="changeFuncionarioByCodigo($event, index)" v-model="data.funcionario.codigo">
                      <input :disabled="StatusNotEdit" class="form-control w-75" :id="'form-funcionario-text-' + index" v-model="data.funcionario.nome">
                  </div>
                </div>
              </div>
              <div class="ml-2 col-md-4">
                <p class="subtitle">Comprovante</p>
                <div class="interface-file" >
                  <i class="fas fa-file-pdf icone-comprovante" v-if="dataExpenseDetails.midia.name.includes('.pdf')"></i>
                  <i class="far fa-file-excel icone-comprovante" v-if="dataExpenseDetails.midia.name.includes('.xlsx')"></i>
                  <img class="image-comprovante" @click="showpdf" v-else-if="!dataExpenseDetails.midia.name.includes('.pdf') && !dataExpenseDetails.midia.name.includes('.xlsx')" :src="'data:image/png;base64,' + midiapdf" />
                  <div class="edit-file" @click="downloadComprovante"><i class="fas fa-download"></i></div>
                  <div class="footer-file">
                    {{dataExpenseDetails.midia.name === null || dataExpenseDetails.midia.name === undefined ? "N/D" : dataExpenseDetails.midia.name}}
                  </div>
                </div>
              </div>
              <div class="ml-2 col-md-4" v-if="dataExpenseDetails.motivoRecusa != null">
                <p class="subtitle">Motivo Devolução</p>
                <div class="caxa-texto conteiner">
                    <textarea class="Ajuste-Devolucao form-control mt-3" rows="8" cols="100" disabled="true" v-model="dataExpenseDetails.motivoRecusa"></textarea>
                </div>
              </div>
            </div>
           </div>
          </b-tab>
          <b-tab :title="'Log'">
            <template slot="title">
              <i class="fas fa-tasks text-third"></i><span class="d-md-down-none pl-1 text-third"> Log</span>
            </template>
            <div class="p-3">
              <div class="subtitle mb-3">Log de Status</div>
              <LogDespesa :despesa-id="despesaviagemid" modulo="viagem" />
            </div>
          </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <b-modal ref="modal-showpdf"    hide-footer
              centered title="COMPROVANTE">
                <img
                  v-if="!this.isPdf"
                  style="overflow: hidden"
                  class="pdf-overview"
                  :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf ">
                <object v-if="this.isPdf"><embed type="text/html"  width="100%" height="600"  :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf" /></object>
    </b-modal>
    <!-- <b-modal ref="devolver-despesa"
            size="md"
            centered
            id="add-brower-modal"
            title="Devolução da Despesa"
            :hide-footer="true"
            :clickToClose="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
    >
        <div>
            <div class="label conteiner">Informe o motivo da devolução!</div>
            <div class="caxa-texto conteiner">
                <textarea class="form-control mt-3" rows="10" cols="175" v-model="motivo"></textarea>
            </div>
        </div>
        <div class="conteiner pt-3">
            <button @click="voltar" class="button-cancel">VOLTAR</button>
            <button @click="DisaApprovedDespesaByid" class="button-save">SALVAR</button>
        </div>
    </b-modal> -->
    <RefuseModalReturnTrip :modalReturn="modalReturn" :detalheDespesa="dataExpenseDetails.id" :viagemMetodoUnico="1"></RefuseModalReturnTrip>
    <b-modal ref="modalAprovarTecnicoDetails" hide-footer centered title="Aprovar — Escolha o Coordenador" size="md">
      <addTecnicoViagem
        :despesasidEnviarCoordenador="despesaIdTecnico"
        :UnicaDespesa="true"
        @fecharEnviarCoordenador="fecharModalTecnico"
        @fechaModalAprovacaoEnvioCoordenador="onAprovouTecnico"
        @onloadReacarregar="onAprovouTecnico"></addTecnicoViagem>
    </b-modal>
  </div>
  </template>
<script>
import Tools from '@/components/tools/Tools.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import roles from '@/shared/utils/roles'
import { loading, toast } from '@/shared/utils/UIHelper'
import PermisionMixin from '@/store/module/permission/mixin'
import DetailsHeader from '@/views/private/realestate/components/HeadDetails.vue'
import LogDespesa from '@/views/private/miscellaneousreimbursement/components/LogDespesa/LogDespesa.vue'
import RefuseModalReturnTrip from '../RefuseModalReturnTrip/RefuseModalReturnTrip.vue'
import addTecnicoViagem from '../addTecnicoViagem/addTecnicoViagem.vue'

export default {
  name: 'Details',
  mixins: [ActionsForm, PermisionMixin],
  components: {DetailsHeader, RefuseModalReturnTrip, addTecnicoViagem, LogDespesa},
  props: ['dataExpenseDetails'],
  data () {
    return {
      despesaviagemid: null,
      midiapdf: null,
      isPdf: false,
      type: null,
      roles: roles,
      StatusNotEdit: false,
      dataAllSubCategoria: [],
      funcionarioVinculados: [],
      tabIndex: 0,
      dataEnumCategoria: [],
      dataAllTipoVeiculo: [],
      editfuncionario: 0,
      funcionariolistainicio: [],
      funcionarioarray: [],
      viagemMetodo: null,
      viagemMetodoUnico: null,
      lstdespesa: [],
      modalReturn: false,
      despesas: [],
      despesa: '',
      motivo: null,
      load: false,
      viagem: null,
      viagemUnico: null,
      dataExpenseDetailsProp: {},
      despesaIdTecnico: null
    }
  },
  mounted () {
    this.GetEmpresa()
    this.despesaviagemid = this.dataExpenseDetails.id
    this.dataExpenseDetailsProp = this.dataExpenseDetails
    this.loadImage()
    this.getFuncionarioVinculados()
    this.getFuncionarioInicial()
    this.GetCategoria()
    if (this.dataExpenseDetails.categoria === 0) {
      this.GetSubCategoria()
    } else {
      this.GetSubCategoriaVeiculo()
      this.getTipoVeiculo()
    }
  },
  watch: {
    'dataExpenseDetails.statusDespesa': function (value) {
      // Admin edita em qualquer status, EXCETO Diretoria (3).
      if (this.hasRole(roles.RW_REAL_ESTA_ADMIN)) {
        this.StatusNotEdit = value === 3
        return
      }
      if (value >= 2) {
        if (value === 3) {
          this.StatusNotEdit = !this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL)
        } else if (value === 2) {
          this.StatusNotEdit = !this.hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)
        } else {
          this.StatusNotEdit = true
        }
      } else {
        this.StatusNotEdit = false
      }
    },
    lstdespesa (value) {
      this.despesas = value
    },
    detalheDespesa (value) {
      this.despesa = value
    },
    viagemMetodo (value) {
      this.viagem = value
    },
    viagemMetodoUnico (value) {
      this.viagemUnico = value
    }
  },
  computed: {
    verificardisablechangeStatus: function () {
      if (this.dataExpenseDetails === null || this.dataExpenseDetails === undefined) return false
      if (parseInt(this.dataExpenseDetails.statusDespesa) <= 2) {
        if (parseInt(this.dataExpenseDetails.statusDespesa) === 2) {
          return this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)
        }
        if (parseInt(this.dataExpenseDetails.statusDespesa) === 3) {
          return this.hasRole(this.roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL)
        }
        return true
      }
      return false
    }
  },
  methods: {
    downloadComprovante () {
      var a = document.createElement('a')
      const typefile = this.dataExpenseDetails.midia.name.includes('.pdf') ? 'application/pdf' : 'image/png'
      a.href = `data:${typefile};base64,` + this.midiapdf
      a.download = this.dataExpenseDetails.midia.name
      a.click()
    },
    changeFuncionarioByCodigo (codigo, index) {
      loading.push()
      this.editfuncionario = index
      EmployeeRepository.codigoFuncionario(codigo.target.value)
        .then((Response) => {
          if (Response.data.code === 200) {
            let data = {
              id: Response.data.data.id,
              funcionario: {
                codigo: Response.data.data.codigo,
                nome: Response.data.data.nome
              }
            }
            this.funcionarioVinculados[this.editfuncionario] = data
            document.getElementById('form-funcionario-code-' + this.editfuncionario).value = data.funcionario.codigo
            document.getElementById('form-funcionario-text-' + this.editfuncionario).value = data.funcionario.nome
          } else {
            toast.error('Não foi possivel encontrar um funcionario!')
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    nomeCurto (nome) {
      if (!nome) return ''
      let p = nome.trim().split(/\s+/)
      return p.length > 1 ? p[0] + ' ' + p[p.length - 1] : nome
    },
    changeSubCategoria () {
      if (this.dataExpenseDetails.categoria === 0) {
        this.GetSubCategoria()
      } else {
        this.GetSubCategoriaVeiculo()
      }
    },
    getFuncionarioVinculados () {
      loading.push()
      TravelExpenseRepository.GetFuncionarioVinculados(this.dataExpenseDetails.id)
        .then((Response) => {
          this.funcionarioVinculados = Response.data
          this.verificafuncionario()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop(0)
        })
    },
    getFuncionarioInicial () {
      loading.push()
      TravelExpenseRepository.GetFuncionarioVinculados(this.dataExpenseDetails.id)
        .then((Response) => {
          this.funcionariolistainicio = Response.data
          this.verificafuncionarioinicio()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop(0)
        })
    },
    returnFormatedData () {
      let data = new Date(this.dataExpenseDetails.dataRegistroDespesa)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },
    returnFormatedDataCoordernador () {
      let data = new Date(this.dataExpenseDetails.dataAtualizacaoCoordenador)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },
    returnFormatedDataRecusa () {
      let data = new Date(this.dataExpenseDetails.dataMotivoRecusa)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },

    GetSubCategoria () {
      loading.push()
      TravelExpenseRepository.GetSubCategoria()
        .then((Response) => {
          this.dataAllSubCategoria = Response.data
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    ApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.ApprovedDespesaByid(this.despesaviagemid)
        .then((Response) => {
          if (Response.status === 200) {
            this.dataExpenseDetails.colorStatusDespesa = Response.data.colorStatusDespesa
            this.dataExpenseDetails.statusDespesaDescricao = Response.data.statusDespesaDescricao
            this.dataExpenseDetails.statusDespesa = Response.data.statusDespesa
          }
          toast.success('Despesa Aprovada com sucesso')
          loading.pop()
          setTimeout(() => {
            this.back()
          }, 3000)
        })
        .catch((Error) => {
          loading.pop()
          toast.warning((Error && Error.response && Error.response.data) ? Error.response.data : 'Não foi possível aprovar a despesa')
        })
    },
    abrirModalTecnico () {
      this.despesaIdTecnico = this.despesaviagemid
      this.$refs['modalAprovarTecnicoDetails'].show()
    },
    fecharModalTecnico () {
      this.$refs['modalAprovarTecnicoDetails'].hide()
    },
    onAprovouTecnico () {
      this.$refs['modalAprovarTecnicoDetails'].hide()
      this.back()
    },
    // ADMIN: avanca conforme o status atual. 9 = escolhe coordenador (modal); 1/2 = avanca (ApprovedDespesaByid).
    aprovarAdmin () {
      if (this.dataExpenseDetails.statusDespesa === 9) {
        this.abrirModalTecnico()
      } else {
        this.ApprovedDespesaByid()
      }
    },
    PreApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.PreApprovedDespesaByid(this.despesaviagemid)
        .then((Response) => {
          if (Response.status === 200) {
            toast.success('Despesa Pré-aprovada com sucesso')
            loading.pop()
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error)
        })
    },
    getTipoVeiculo () {
      loading.push()
      TravelExpenseRepository.GetTipoVeiculo()
        .then((Response) => {
          this.dataAllTipoVeiculo = Response.data
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    // DisaApprovedDespesaByid () {
    //   loading.push()
    //   TravelExpenseRepository.DisaApprovedDespesaByid({motivoRecusa: this.motivo, despesaviagemid: this.dataExpenseDetails.id, reprovacaoDefinitiva: this.definitivo})
    //     .then((Response) => {
    //       toast.success('Despesa Reprovada com sucesso')
    //       this.dataExpenseDetails.colorStatusDespesa = Response.data.colorStatusDespesa
    //       this.dataExpenseDetails.statusDespesaDescricao = Response.data.statusDespesaDescricao
    //       this.dataExpenseDetails.statusDespesa = Response.data.statusDespesa
    //       // this.$refs['devolver-despesa'].hide()
    //       this.modalReturn = false
    //       this.$emit('Load', !this.load)
    //       loading.pop()
    //     })
    //     .catch((Error) => {
    //       loading.pop()
    //       toast.warning(Error)
    //     })
    // },
    showpdf () {
      this.$refs['modal-showpdf'].show()
    },
    loadImage () {
      loading.push()
      let midiaName = this.dataExpenseDetails.midia.name
      this.type = this.dataExpenseDetails.midia.name.split('.').pop()
      this.isPdf = midiaName.toLowerCase().includes('pdf')
      TravelExpenseRepository.Download(this.dataExpenseDetails.midia.id, this.CompanySelected).then((e) => {
        this.midiapdf = e.data
      }).catch(() => {
        toast.error('Não foi possivel carregar o comprovante')
        loading.pop()
      })
        .finally(() => { loading.pop() })
    },
    GetSubCategoriaVeiculo () {
      loading.push()
      TravelExpenseRepository.GetEnumSubCategoriaVeiculo()
        .then((Response) => {
          loading.pop()
          this.dataAllSubCategoria = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    GetCategoria () {
      TravelExpenseRepository.GetCategoria()
        .then((Response) => {
          this.dataEnumCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },

    UpdateDespesasViagem () {
      loading.push()
      let funcionarioids = this.funcionarioVinculados.map((Element) => {
        if (Element.id !== undefined) {
          return Element.id
        }
      })
      this.dataExpenseDetails['Funcionarioids'] = funcionarioids.filter((Element) => Element !== undefined)
      TravelExpenseRepository.UpdateDespesasViagem(this.dataExpenseDetails)
        .then((Response) => {
          toast.success('Alteração Realizado com sucesso')
          this.$emit('voltarGrid')
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error)
        })
        .finally(() => {
          loading.pop()
        })
    },

    verificafuncionario () {
      this.funcionarioarray = this.funcionarioVinculados
      let funcionariocolaborador = this.dataExpenseDetails.funcionarioDespesaId

      this.funcionarioarray.forEach((e, index) => {
        if (e.funcionarioID === funcionariocolaborador) {
          const funcionarioLogado = this.funcionarioarray.find((funcionario) => {
            return funcionario.funcionarioID === funcionariocolaborador
          })
          this.funcionarioarray.splice(index, 1)
          this.funcionarioarray.unshift(funcionarioLogado)
        }
      })
    },
    verificafuncionarioinicio () {
      this.funcionarioarray = this.funcionariolistainicio
      let funcionariocolaborador = this.dataExpenseDetails.funcionarioDespesaId

      this.funcionarioarray.forEach((e, index) => {
        if (e.funcionarioID === funcionariocolaborador) {
          const funcionarioLogado = this.funcionarioarray.find((funcionario) => {
            return funcionario.funcionarioID === funcionariocolaborador
          })
          this.funcionarioarray.splice(index, 1)
          this.funcionarioarray.unshift(funcionarioLogado)
        }
      })
    },
    addfuncionario () {
      let data = {
        funcionario: {
          codigo: null,
          nome: null
        }
      }
      this.funcionarioVinculados.push(data)
    },
    removerfuncionario (response) {
      this.funcionarioVinculados.splice(response, 1)
    },
    back () {
      document.location.reload()
    },
    modal () {
      // this.$refs['modal-EscolhaReprova'].show()
      this.modalReturn = true
    },
    voltar () {
      this.motivo = null
      this.despesas = []
      // this.$refs['devolver-despesa'].hide()
      this.modalReturn = false
    },
    // voltarEscolhaReprova () {
    //   this.$refs['modal-EscolhaReprova'].hide()
    // },
    GetEmpresa () {
      TravelExpenseRepository.GetEmpresa(this.CompanySelected)
        .then(Response => {
          this.local = Response.data.localidade
          this.$emit('localidade', this.local)
        })
    }
  }
}
</script>

<style scoped>
.Ajuste-Devolucao{
  border-radius: 13px;
}
.gap{
    gap: 0.5rem;
}
.card-totalDespesas{
    padding-right: 0;
    padding-left: 0
}
.image-comprovante{
    height: 75%;
    border-radius: 10px;
    width: 60%;
    object-fit: contain;
}
.pdf-icon-container{
  width: 100%;
  height: 100%;
  display:flex;
  justify-content: center;
  align-items: center;

}
.pdf-overview{
    height: 657px;
    width: 100%;
  }
  .gap-input-funcionario{
    display: flex;
    gap: 5px;
}
  .panel-details {
    height: fit-content;
}
  .info-panel-details{
    padding: 20px;
  }
  .panel-info-details{
    height: fit-content;
    padding: 15px;
    background: white;
  }
  .obs-heigth{
    min-height: 10vh;
  }
  .footer-file{
    height: 30px;
    width: 100%;
    color: rgb(163, 163, 163);
    border-radius: 0px 0px 10px 10px;
    background: #eceff1;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .edit-file{
    height: 25px;
    width: 40px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    border-radius: 0 10px 0 10px;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    background: #008144;
  }
  .interface-file {
    position: relative;
    color: #c8cbcc;
    height: 175px;
    cursor: pointer;
    border: 1px solid gainsboro;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    font-size: 60px;
    width: 220px;
  }
    .panel-body{
    border: 1px solid rgb(211, 210, 210);
    overflow: auto;
    border-radius: 10px;
    height: 100%;
  }
  .subtitle {
    font-size: 16px;
    color: #008144;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 20px;
  }
  .buttons-footer{
    height: 25%;
    align-items: center;
    flex-direction:column ;
    display: flex;
  }
  .label{
    font-size: 14px;
    line-height: 0px;
    font-weight: 400;
  }
  .label-data{
    line-height: 13px !important;
  }
  .value{
    font-size: 14px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .apr{
    background: #008144;
  }
  .apr:hover{
    background: #03a358;
  }
  .rep{
    background: red;
  }
  .rep:hover{
    background: rgb(197, 3, 3);
  }
  .button-panel{
    width: 75%;
    color: white;
    margin-bottom: 10px;
    height: 40px;
    border: none;
    border-radius: 10px;
    font-weight: bold;
  }
  .info-panel {
    position: relative;
    height: fit-content;
    padding: 0px;
    background: white;
    border-radius: 10px;
  }
  .panel-details-head{
    height: 40px;
    background: #eceff1;
    padding-left: 15px;
    border-radius: 10px 10px 0px 0px;
    color: #008144;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .panel-details-body{
    padding: 20px;
    max-height: 90%;
  }
  .status-despesas-viagem{
    padding: 4px 16px;
    display: flex;
    width: fit-content;
    margin-top: 6px;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    background: #008144;
    color: white;
  }
  @media (max-width: 1280px) {
  .statusDespesa {
    font-size: 11px;
  }
  }
  @media (min-width: 1281px) {
    .statusDespesa {
      font-size: 12px;
    }
  }
  .add-more-people{
      color: #008144;
      font-size: 17px;
      display: flex;
      text-decoration: underline;
      cursor: pointer;
      align-items: center;
  }
  .remove-more-people{
     font-size: 17px;
      color: red;
      cursor: pointer;
      display: flex;
      align-items: center;
  }
  .label-details-despesas{
    font-size: 14px;
    font-weight: bold;
    line-height: 2px;
}

.button-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
}
.button-save {
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(4, 90, 30);
}
@media (min-width:1423px) {
  .interface-file {
    height: 175px;
    width: 390px;
  }
}

/* CANCELAR/SALVAR no padrao dos botoes da prestacao de contas (pill vermelho/verde) — so nesta tela */
::v-deep .btn-head-can {
  background-color: #c82333;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: .45rem 1.4rem;
  font-weight: 600;
}
::v-deep .btn-head {
  background-color: #008148;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: .45rem 1.4rem;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/components/details/details.vue